fx.ns("models", class ProductPrint extends  models.Creation {

	constructor(data)
	{
		super(data);

        this.product_type_id = models.ProductType.PRINT;
	}

    get prints()
    {
        return this.elements;
    }

    get numPrints()
    {
        var numPrints = 0;
        for(var i = 0; i < this.elements.length; i++)
        {
            let print = this.elements.getItemAt(i);
            if(print.quantity)
            {
                numPrints+=print.quantity;
            }
        }
        return numPrints;
    }

    get pricePerPrint()
    {
        return (this.creationOption.price_base * fx.get("lang").tax).toFixed(2); 
    }

    get totalPrice()
    {
		return this.calculatePrice();
    }

    get pageWidth()
    {
        let width = 0;
        switch(this.creationOption.format.style)
        {
            case "square":
                width = 210;
                break;
            case "portrait":
                width = 210;
                break;
            case "landscape":
                width = 297;
                break;
        }
        return width;
    }

    get pageHeight()
    {
        let height = 0;
        switch(this.creationOption.format.style)
        {
            case "square":
                height = 210;
                break;
            case "portrait":
                height = 297;
                break;
            case "landscape":
                height = 210;
                break;
        }
        return height;
    }

    get creationOption()
    {
        return this._creationOption;
    }

    set creationOption(val)
    {
        this._creationOption = val;
    }

     // to override
	get minPages()
	{
		return this.creationOption.min_pages;
	}

    get maxPages()
	{
		return this.creationOption.max_pages;
	}
	
	calculatePrice()
	{
        var price = this.numPrints * this.pricePerPrint;
        return price.toFixed(2) + " €" ;
	}

    addPrint(referenceElement)
    {
        let newElement = new models.ProductPrintPage({creation_id : this.id, layoutid : 0});
			
		let index = referenceElement ? ((referenceElement && referenceElement !== true) ? (this.elements.indexOf(referenceElement)+1) : 0) : this.elements.length;

		this.elements.addItemAt( index, newElement );

		newElement.addBackground();

		this.updateNumbering();

        return newElement;
    }

});
